export default __webpack_public_path__ + "static/media/oneidlg.1ee04421.png";